import React, { FunctionComponent } from "react";
import Box from "@mui/material/Box";

import Text from "designSystem/components/text/Text";

interface DataSetupItemPlaceholderProps {
	/** the description of the placeholder */
	description: string;
}

const DataSetupItemPlaceholder: FunctionComponent<DataSetupItemPlaceholderProps> = (props) => {
	const { description } = props;

	return (
		<Box
			bgcolor="grey.100"
			borderRadius="3px"
			mx={4}
			p={2}
		>
			<Text text={description} />
		</Box>
	);
};

export default DataSetupItemPlaceholder;